/**
* Ponyfill for Array.prototype.find
* @param {Array} arr
* @param {Function} checkFn
* @return item in the array
*/
export default function find(arr, checkFn) {
  if (Array.prototype.find) {
    return arr.find(checkFn)
  }

  // use `filter` as fallback
  return arr.filter(checkFn)[0]
}



// WEBPACK FOOTER //
// ./src/Tooltip/js/utils/find.js


// WEBPACK FOOTER //
// webpack:///src/Tooltip/js/utils/find.js